import React from "react";
import useTranslation from '../hooks/useTranslation';

// Shared Dashboard UI components to eliminate duplicate rendering patterns

export function EmptyState({ message }) {
  return (
    <div className="dash-state dash-state--empty">
      <span className="dash-state__icon" role="img" aria-label="Empty">📭</span>
      <p className="dash-state__text">{message}</p>
    </div>
  );
}

export function MoodBalanceBar({ title, posPct }) {
  const { t } = useTranslation();
  const fillClass = posPct > 60
    ? 'mood-bar__fill--good'
    : (posPct > 40 ? 'mood-bar__fill--mid' : 'mood-bar__fill--low');

  return (
    <div className="dash-emotions-box" style={{ padding: 12 }}>
      <div className="dash-emotions-title">{title}</div>
      <div style={{ marginTop: 12 }}>
        <div
          className="mood-bar"
          role="progressbar"
          aria-valuenow={Number(posPct.toFixed(1))}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={title}
        >
          <div className={`mood-bar__fill ${fillClass}`} style={{ width: `${posPct}%` }} />
        </div>
        <div className="mood-bar__legend">
          <span>{t('Positive')}</span>
          <span>{posPct.toFixed(1)}%</span>
        </div>
      </div>
    </div>
  );
}

export function DominantEmotionSummary({ period, dominant, stressDelta, EMOJI }) {
  const { t } = useTranslation();
  const sameLabel = t(`Stress was about the same as last ${period}.`);
  const droppedLabel = t(`Stress dropped compared to last ${period}.`);
  const increasedLabel = t(`Stress increased compared to last ${period}.`);

  return (
    <div className="summary-box">
      <div className="summary-box__heading">{t(`This ${period}`)}</div>
      <div className="summary-box__row">
        <span className="summary-box__emoji" role="img" aria-label={dominant.name}>{EMOJI[dominant.raw] || '🙂'}</span>
        <div className="summary-box__label">
          <div className="summary-box__strong">{t('Mostly')} {dominant.name}</div>
          {stressDelta != null && (
            <div className="summary-box__note">
              {Math.abs(stressDelta) < 0.5 ? sameLabel : (
                stressDelta < 0 ? droppedLabel : increasedLabel
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
